// Mirrors FLEXIBLE_TRIP_ANCHOR in voia-travel-mobile app/utils/tripDates.ts.
export const FLEXIBLE_TRIP_ANCHOR = new Date(1900, 0, 1, 12, 0, 0, 0);
